import { supabase } from '../supabase/client';

export const getUsers = async () => {
  const {
    data: { users },
    error,
  } = await supabase.auth.admin.listUsers();

  if (error) {
    throw error;
  }

  return users;
};

export const updateUserRole = async (id, isAdmin) => {
  const { data, error } = await supabase.auth.admin.updateUserById(id, {
    user_metadata: { isAdmin },
  });

  if (error) {
    throw error;
  }

  return data;
};

export const deleteUser = async id => {
  const { error } = await supabase.auth.admin.deleteUser(id);

  if (error) {
    throw error;
  }
};
